/**
=========================================================
* E4A-IoT-Manager React Frontend Dashboard 
* Copyright © 2024 Electronics4All Inc.
=========================================================
*/
// React hooks and part code management service
import { useEffect, useState } from "react";

// MUI and Material Dashboard Components
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

export default function EditPartCode({
    handleClose,
    open,
    node,
}) {

    // Used to store the additional notes and quantity of the part code in the BOM
    const [additionalData, setAdditionalData] = useState({
        text: "",
        quantity: 1
    });

    useEffect(() => {
        setAdditionalData({
            text: node?.data?.text || "",
            quantity: node?.data?.quantity || 1
        });
    }, [node]);


    // Generate the display string from the prop
    const partCodeDisplay = node?.data?.name || "N/A";

    const commonProps = { // Props common for the input fields
        display: "flex",
        flexDirection: "column",
        fullWidth: true,
        marginBottom: "1rem",
        marginTop: "1rem"
    };

    // Handles the saving of the edited part code
    const handleSave = () => {
        const notes = additionalData.text;
        const quantity = additionalData.quantity;

        setAdditionalData({
            text: "",
            quantity: 1
        });

        handleClose("save", quantity, notes, node)
    };

    const onClose = () => {

        setAdditionalData({
            text: "",
            quantity: 1
        })

        handleClose("cancel")
    }

    // Change Handler for the additional notes and quantity fields
    const changeHandler = (e) => {
        setAdditionalData({
            ...additionalData,
            [e.target.name]: e.target.value
        })
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>Edit Part Code Entry</DialogTitle>
            <DialogContent>
                <MDBox margin={2}>
                    {/* Part Code Display */}
                    <MDBox display="flex" justifyContent="center" alignItems="center" mb={2}>
                        <MDTypography variant="h4" fontWeight="medium">
                            {partCodeDisplay}
                        </MDTypography>
                    </MDBox>

                    {/* Additional Notes Field */}
                    <MDBox {...commonProps}>
                        <MDInput
                            label="Additional Notes"
                            name="text"
                            value={additionalData.text}
                            onChange={changeHandler}
                            variant="standard"
                            fullWidth
                        />
                    </MDBox>

                    {/* Quantity Field */}
                    <MDBox {...commonProps}>
                        <MDInput
                            label="Quantity"
                            name="quantity"
                            type="number"
                            value={additionalData.quantity}
                            onChange={changeHandler}
                            variant="standard"
                            fullWidth
                        />
                    </MDBox>

                </MDBox>
            </DialogContent>
            <DialogActions>


                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleSave}>Save</Button>

            </DialogActions>
        </Dialog>
    )
}